module.exports = __webpack_public_path__ + "static/media/cd-helios.61850d1a.jpg";